export enum AccessType {
  Dev = 'Dev',
  Admin = 'Admin',
  Reporter = 'Reporter',
  PmiAdmin = 'PmiAdmin',
}

export function mapAccessTypeToLabel(
  accessType: string | null | undefined,
): string {
  const key = String(accessType ?? '').trim() as AccessType;

  switch (key) {
    case AccessType.Dev:
      return 'Developer';
    case AccessType.Admin:
      return 'Admin';
    case AccessType.Reporter:
      return 'Reporter';
    case AccessType.PmiAdmin:
      return 'PMI Admin';
    default:
      return '';
  }
}
